import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

import ActiveSeedProductInputs from 'edit/seed-product-selector/ActiveSeedProductInputs';
import { getCropBasedMessage } from 'util/locale';

const baseString = 'vra-active-seed-products';
const classString = classNames({
  [`${baseString}`]: true
});
const ActiveSeedProducts = ({
  activeSeedProductsByInput,
  onClickRemoveActiveProductTrigger,
  numActiveSeedProducts
}) => {
  const cropId = useSelector(getActiveCropId);
  return (
    <section className={classString}>
      <header className={`${baseString}__title`}>
        {getCropBasedMessage({ key: 'title-text__seed-finder-shelf', cropId })}
      </header>
      {
        numActiveSeedProducts ? (
          <ActiveSeedProductInputs
            activeSeedProductsByInput={activeSeedProductsByInput}
            onClickRemoveActiveProductTrigger={onClickRemoveActiveProductTrigger}
          />
        ) : (
          <p className={`${baseString}__placeholder-text`} data-test-id={`${baseString}__placeholder-text`}>
            {getCropBasedMessage({ key: 'placeholder-text__seed-finder-shelf', cropId })}
          </p>
        )
      }
    </section>
  );};
ActiveSeedProducts.propTypes = {
  activeSeedProductsByInput: PropTypes.object.isRequired,
  numActiveSeedProducts: PropTypes.number.isRequired,
  onClickRemoveActiveProductTrigger: PropTypes.func.isRequired
};
export default ActiveSeedProducts;
